import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6 54.115L44.85 40.363c-.26-.26-.6-.396-.963-.396h-1.495a23.498 23.498 0 005.732-15.406C48.123 11.546 37.577 1 24.56 1 11.546 1 1 11.546 1 24.561c0 13.016 10.546 23.562 23.561 23.562 5.89 0 11.271-2.164 15.406-5.732v1.495c0 .363.147.702.396.963l13.752 13.752a1.36 1.36 0 001.926 0l2.56-2.56a1.36 1.36 0 000-1.926z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 43C14.279 43 6 34.721 6 24.5S14.279 6 24.5 6 43 14.279 43 24.5 34.721 43 24.5 43z",
    fill: "#FFF",
    opacity: 0.88
  })));
};
export default SvgSearch;